import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { isString } from 'lodash';
import { ehLicencaVencida } from "./licencaRules";

// Erro precisa de tempo de leitura. Ficava 2s e sumia sozinho, e como
// `closeOnClick` estava ligado, qualquer clique na tela derrubava o aviso antes
// de alguem terminar de ler — justamente nas mensagens mais longas, que sao as
// que explicam o que fazer (ex.: janela de 24h fechada sem template aprovado).
//
// Agora: 10s, o relogio pausa enquanto o mouse esta em cima, e so o X fecha.
// Exportado para que chamadas diretas a `toast.error` possam usar o mesmo
// comportamento sem redefinir as opcoes: toast.error(msg, opcoesDeErro).
export const opcoesDeErro = {
	autoClose: 10000,
	hideProgressBar: false,
	// Fechar so pelo X: clique no corpo do toast nao descarta mais sem querer.
	closeOnClick: false,
	closeButton: true,
	pauseOnHover: true,
	draggable: true,
	progress: undefined,
	theme: "light",
};

const toastError = err => {
	// Licenca vencida e tratada por redirecionamento; nao vira toast.
	if (ehLicencaVencida(err)) return;
	const errorMsg = err.response?.data?.error;
	if (errorMsg) {
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
				...opcoesDeErro,
			});
			return
		} else {
			toast.error(errorMsg, {
				toastId: errorMsg,
				...opcoesDeErro,
			});
			return
		}
	} if (isString(err)) {
		toast.error(err, opcoesDeErro);
		return
	} else {
		toast.error("An error occurred!", opcoesDeErro);
		return
	}
};

export default toastError;